/**
 * One source of truth for the legal pages and the acceptance prompt.
 *
 * TERMS_VERSION must match LegalService.CURRENT_TERMS_VERSION on the API.
 * Bumping it here and there is what asks every existing member to agree again
 * (see TermsGate), so only bump it when the Terms text actually changes in a
 * way people should read.
 */

export const TERMS_VERSION = "2026-07-26";

export const TERMS_EFFECTIVE = "October 31, 2026";
export const PRIVACY_EFFECTIVE = "October 31, 2026";

/** Brand people see. */
export const BRAND = "BookieBrawler";

/**
 * The operating entity named in the agreement.
 *
 * TODO(owner): confirm the exact registered name and mailing address before
 * these pages go live — everything published here flows from these two
 * constants, so correcting them is a one-line change.
 */
export const LEGAL_ENTITY = "Blooish LLC";
export const LEGAL_ADDRESS = "1125 West Street, Ste 200, Annapolis, MD 21401";
export const GOVERNING_STATE = "Maryland";

/**
 * Deliberately a real, monitored inbox. A notice address in the Terms that
 * bounces is worse than no notice address at all.
 */
export const LEGAL_EMAIL = "support@bookiebrawler.com";
export const SUPPORT_EMAIL = "support@bookiebrawler.com";

export const TERMS_PATH = "/terms";
export const PRIVACY_PATH = "/privacy";
export const RESPONSIBLE_GAMBLING_PATH = "/blog/responsible-gambling-guide";

/** Subscription facts quoted in the Terms — keep in step with the pricing page. */
export const PLAN_FACTS = {
  tiers: "Bronze, Silver, and Gold",
  trialDays: 7,
  refundDays: 14,
};
